import React from 'react';
import {Card, Checkbox, Col, Form, Row, Typography} from 'antd';
import PropTypes from 'prop-types';

import {accountCreationCheckBoxError} from '../../helpers/text';

const {Text} = Typography;

const AccountCreateReview = ({
                                   isBusiness,
                                   firstName,
                                   lastName,
                                   birthDate,
                                   email,
                                   businessName,
                                   nameOnContract,
                                   dbaName,
                                   websiteAddress,
                                   taxRegistrationNumber,
                                   businessRegistrationNumber,
                                   industryCode,
                                   companySize,
                                   checked,
                                   setChecked,
                                   showCheckBoxError,
                               }) => {
    const [form] = Form.useForm();

    const onChange = (e) => {
        setChecked(e.target.checked);
    }

    // This element goes in different places depending on if it's a pre-existing or new person or business.
    const checkBoxJSX = (
        <>
            <Checkbox
                checked={checked}
                onChange={onChange}
            >
                I confirm that the information above is up to date and accurate.
            </Checkbox>
            {showCheckBoxError && accountCreationCheckBoxError}
        </>
    );

    return (
        <Form
            form={form}
            id="account-creation-review"
            name="account-creation-review"
        >
            <Card
                title={<span className="account-create-information-title">Profile Information</span>}
            >
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>First Name:</Text>
                    </Col>
                    <Col xs={24} md={20}>{firstName}</Col>
                </Row>
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Last Name:</Text>
                    </Col>
                    <Col xs={24} md={20}>{lastName}</Col>
                </Row>
                {
                    birthDate &&
                    <Row>
                        <Col xs={24} md={4}>
                            <Text strong>Birth Date:</Text>
                        </Col>
                        <Col xs={24} md={20}>{birthDate ? birthDate.format('DD MMM YYYY') : null}</Col>
                    </Row>
                }
            </Card>
            <br/>
            {!email && !isBusiness ? checkBoxJSX : null}
            {!email && !isBusiness ? <p className="check-box-additional-space"/> : null}
            <Card
                title={<span className="account-create-information-title">Login Information</span>}
            >
                <Row>
                    <Col xs={24} md={4}>
                        <Text strong>Email:</Text>
                    </Col>
                    <Col xs={24} md={20}>{email ? email : 'N/A'}</Col>
                </Row>
            </Card>
            <br/>
            {email && !isBusiness ? checkBoxJSX : null}
            {
                isBusiness && <>
                    <Card
                        title={<span className="account-create-information-title">Company Information</span>}
                    >
                        <Row>
                            <Col xs={24} md={8}>
                                <Text strong>Business Name:</Text>
                            </Col>
                            <Col xs={24} md={16}>{businessName}</Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={8}>
                                <Text strong>Name on Contract:</Text>
                            </Col>
                            <Col xs={24} md={16}>{nameOnContract}</Col>
                        </Row>
                        {
                            dbaName &&
                            <Row>
                                <Col xs={24} md={8}>
                                    <Text strong>DBA Name:</Text>
                                </Col>
                                <Col xs={24} md={16}>{dbaName}</Col>
                            </Row>
                        }
                        {
                            websiteAddress &&
                            <Row>
                                <Col xs={24} md={8}>
                                    <Text strong>Website Address:</Text>
                                </Col>
                                <Col xs={24} md={16}>{websiteAddress}</Col>
                            </Row>
                        }
                        {
                            taxRegistrationNumber &&
                            <Row>
                                <Col xs={24} md={8}>
                                    <Text strong>GST/HST Number:</Text>
                                </Col>
                                <Col xs={24} md={16}>{taxRegistrationNumber}</Col>
                            </Row>
                        }
                        {
                            businessRegistrationNumber &&
                            <Row>
                                <Col xs={24} md={8}>
                                    <Text strong>Business Registration Number:</Text>
                                </Col>
                                <Col xs={24} md={16}>{businessRegistrationNumber}</Col>
                            </Row>
                        }
                        {
                            industryCode &&
                            <Row>
                                <Col xs={24} md={8}>
                                    <Text strong>Industry Code:</Text>
                                </Col>
                                <Col xs={24} md={16}>{industryCode}</Col>
                            </Row>
                        }
                        {
                            companySize &&
                            <Row>
                                <Col xs={24} md={8}>
                                    <Text strong>Company Size:</Text>
                                </Col>
                                <Col xs={24} md={16}>{companySize}</Col>
                            </Row>
                        }
                    </Card>
                    <br/>
                    {checkBoxJSX}
                </>
            }
        </Form>
    );
}

AccountCreateReview.propTypes = {
    isBusiness: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    birthDate: PropTypes.object,
    email: PropTypes.string,
    businessName: PropTypes.string,
    nameOnContract: PropTypes.string,
    dbaName: PropTypes.string,
    websiteAddress: PropTypes.string,
    taxRegistrationNumber: PropTypes.string,
    businessRegistrationNumber: PropTypes.string,
    industryCode: PropTypes.string,
    companySize: PropTypes.string,
    checked: PropTypes.bool,
    setChecked: PropTypes.func,
    showCheckBoxError: PropTypes.bool,
};

export default AccountCreateReview;